"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCommitmentToExcellence() {
  const [scrollY, setScrollY] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: false
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const drift = isHovered ? 0 : Math.min(scrollY * 0.05, 10);
  return;
}